import * as React from "react";
import { useState as useComfortState } from "../../../../context/reports/comfort";
import { useActions as useComfortActions } from "../../../../context/reports/comfort/useActions";

interface UseZoneEffects {
  appReady: boolean;
  sites: string[];
  siteId?: string;
}

export function useZoneEffects({ appReady, sites, siteId }: UseZoneEffects) {
  const {
    current,
    compare,
    timeFrameOption,
    compareToOption,
    portfolioLoaded,
    portfolioLoading,
    zonesLoaded,
    zonesLoading,
  } = useComfortState();
  const { getPortfolio, getZones, resetZones } = useComfortActions();
  const didMountRef = React.useRef(false);

  // * If portfolio data has not yet been loaded, request it
  React.useEffect(() => {
    if (appReady && !portfolioLoading && !portfolioLoaded) {
      didMountRef.current = true;
      void getPortfolio({
        siteIds: sites,
        current,
        compare,
      });
    }

    return () => {
      resetZones();
    };
  }, [appReady]);

  // * Request site zones data
  React.useEffect(() => {
    if (siteId && appReady && !zonesLoading && !zonesLoaded) {
      void getZones({
        siteId,
        current,
        compare,
      });
    }
  }, [appReady, siteId]);

  // * If siteId argument is defined, AND
  // * timeFrame changes
  // * Request site zones and portfolio data
  React.useEffect(() => {
    if (
      siteId &&
      appReady &&
      !zonesLoading &&
      zonesLoaded &&
      didMountRef.current
    ) {
      void getZones({
        siteId,
        current,
        compare,
      });
    }

    if (!portfolioLoading && portfolioLoaded && didMountRef.current) {
      void getPortfolio({
        siteIds: sites,
        current,
        compare,
      });
    }

    didMountRef.current = true;
  }, [timeFrameOption, compareToOption, siteId]);
}
